import { getHotjarSettingsValues } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getHotjarSettingsValues";
import { getSettingRecordSessionHotjar } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingRecordSessionHotjar";
import { trackHotjarConfigFailedToInitialize } from "@faire/web-api--source/events/hotjarConfig/actionCategoryOther/failedToInitialize";
import { trackHotjarConfigInitialized } from "@faire/web-api--source/events/hotjarConfig/actionCategoryOther/initialized";
import { trackHotjarConfigHotjarSettingConfigLimitExceededError } from "@faire/web-api--source/events/hotjarConfig/error/hotjarSettingConfigLimitExceeded";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { Hotjar } from "@faire/web/common/hotjar/hotjar";
import { filterAndProcessHotjarSettings } from "@faire/web/common/hotjar/hotjarUtils";
import { getLocaleKey } from "@faire/web/common/serialized-data/getLocaleKey";
import { uuid } from "@faire/web/common/uuid";

const HOTJAR_ID = 3000850;
const HOTJAR_SNIPPET_VERSION = 6;
const HOTJAR_CONFIG_MAX_SETTINGS = 80;

export const initializeHotjar = async (
  user: IUser | undefined = IUser.build(),
  isAdminUser: boolean
) => {
  if (getSettingRecordSessionHotjar() && !isAdminUser) {
    try {
      Hotjar.initialize(HOTJAR_ID, HOTJAR_SNIPPET_VERSION);

      const { impersonating, token, type, retailer_token } = user;
      const language = getLocaleKey()?.language;
      const country = getLocaleKey()?.country;
      const storeType = getGlobalProperty("storeType");
      const hotjarSettingsValues = getHotjarSettingsValues();

      const processedSettings = filterAndProcessHotjarSettings(
        hotjarSettingsValues,
        HOTJAR_CONFIG_MAX_SETTINGS
      );

      const identifyToken = token ?? `logged-out-${uuid()}`;

      Hotjar.identify(identifyToken, {
        impersonating,
        type,
        retailer_token,
        localeLanguage: language,
        localeCountry: country,
        storeType,
        ...processedSettings,
      });

      if (
        Object.values(hotjarSettingsValues).length > HOTJAR_CONFIG_MAX_SETTINGS
      ) {
        // Send Pete Error event if there are more than 80 settings in the config
        trackHotjarConfigHotjarSettingConfigLimitExceededError("web-retailer");
      }
    } catch (_) {
      trackHotjarConfigFailedToInitialize();
      return;
    }

    trackHotjarConfigInitialized();
  }
};
